import React, {useEffect} from 'react';
import '../../../css/AddTripForm/Element.css';
import FormField from '../FormField';

const TransportElement = ({ data, handleChange }) => {
  const isLinked = data.variants.length > 1;
  const handleIsWithLimitedPlaces = async (field, value) => {
    if (value === false)
    {
      handleChange('capacity', null);
    }
    handleChange(field, value);
  }

  return (
    <div className="transportContainer">
      <FormField
    label="Nazwa"
    name="name"
    type="text"
    value={data.name || ''}
    onChange={(field, value) => handleChange(field, value)}
    required
  />

  <FormField
    label="Opis"
    name="description"
    type="richtext"
    value={data.description || ''}
    onChange={(field, value) => handleChange(field, value)}
    placeholder="Aby użyć link wpisz dowolny tekst (np. Klik) a następnie go zaznacz i wybierz ostatni symbol z paska narzędzi. To pozwoli Ci wpisać link."
  />

  <FormField
    label="Czas rozpoczęcia"
    name="startDate"
    type="datetime-local"
    value={data.startDate || ''}
    onChange={(field, value) => handleChange(field, value)}
    required
  />

<FormField
        label="Czy z limitem miejsc?"
        name="isWithLimitedPlaces"
        type="toggle"
        value={data.isWithLimitedPlaces}
        onChange={(field, value) => handleIsWithLimitedPlaces(field, value)}
      />
    {data.isWithLimitedPlaces && (<FormField
        label={"Limit miejsc"}
        name="capacity"
        type="number"
        min="1"
        step="1"
        value={data.capacity?.toString() || ""}
        onChange={(field, value) => handleChange(field, value)}
        required
      />)
    }

<FormField
    label="Link"
    name="link"
    type="text"
    value={data.link || ''}
    onChange={(field, value) => handleChange(field, value)}
  />

<FormField
    label="Ustalona cena (brutto) elementu na osobę"
    name="pricePerPerson"
    info="Pamiętaj o uwzględnieniu buforu (10% oryginalnego kosztu, nie mniej niż 6 zł) i ewentualnym pokryciu kosztów osoby koordynatorskiej"
    type="number"
    value={data.pricePerPerson?.toString() || "" }
    onChange={(field, value) => handleChange(field, value)}/>

      <FormField
        label="Kwota z faktury"
        name="invoiceAmount"
        type="number"
        value={data.invoiceAmount?.toString() || ''}
        onChange={handleChange}
        placeholder="Podaj kwotę z faktury"
        step="0.01"
        min="0"
        unit="zł"
        info="Prognozowana kwota z faktury. Widoczna tylko w widoku Zestawienia. Nie jest wyświetlana na formularzu zapisów."
      />

       <FormField
        label="Komentarz (do rozliczeń)"
        name="internalComment"
        type="textarea"
        value={data.internalComment || ''}
        onChange={handleChange}
        placeholder="Komentarz dla osoby koordynatorskiej"
        info="Widoczny tylko w widoku Zestawienia. Nie jest wyświetlany na formularzu zapisów."
      />
</div>
  );
};

export default TransportElement;
